<template>
    <v-row class="mx-1 my-7">
        <slot name="meta" />

		<v-col v-if="contentData.Title" cols="12">
			<h3 class="q-title text-center">{{ contentData.Title }}</h3>
		</v-col>

		<slot name="Iframes">
			<div class="columns-wrapper align-stretch justify-center" :style="itemsStyle">
                <div v-for="(iframe, key) in contentData.Iframes" :key="key" class="column-item pa-2">
                    <div v-html="iframe.pretext"></div>
                    <div class="iframe-container">
                        <iframe class="responsive-iframe" :src="iframe.src"></iframe>
                    </div>
                    <div v-html="iframe.text"></div>
                </div>
			</div>
		</slot>
    </v-row>
</template>

<script>
import { CmsGroupViewMixin } from '@/CMS/mixins/CmsGroupMixin'

export default {
    name: "IframeGroup",
	mixins: [CmsGroupViewMixin],
    props: {
        contentData: {
            type: Object,
            default: function() {
                return {
                    Iframes: [{}],
                    Title: '',
                    NumColumns: 4,
                }
            }
        }
    },
}
</script>
